import React from "react";
import { GoPlusCircle } from "react-icons/go";
import useTitanApp from "../../../../../../../hooks/useTitanApp";
import { Skeleton } from "@mui/material";
import {
  setShowAddPatientMedicationModal,
  setCurrentPatientMedicationsToEdit,
  setCurrentPatientMedicationsToDelete,
} from "../../../../../../../dispatchers/patientDispatchers";
import { LuPill } from "react-icons/lu";
import { MdOutlineEdit } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";

export default function PatientMedications() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    patientMedications,
    patientMedicationsLoading,
    isConsultationEnabled,
  } = patientState || {};

  const handleEditClick = async (medication) => {
    setShowAddPatientMedicationModal(true);
    setCurrentPatientMedicationsToEdit(medication);
  };
  const handleDeleteClick = async (medication) => {
    setCurrentPatientMedicationsToDelete(medication);
  };

  return (
    <div className="patient-items-wrapper">
      <div className="header-title">
        <h6>Medications</h6>
        <div
          className="add-vital-btn"
          onClick={() => {
            if (!isConsultationEnabled) {
              setShowAddPatientMedicationModal(true);
            }
          }}
        >
          <GoPlusCircle />
          <p>Add Medications</p>
        </div>
      </div>
      <div className="list-items vitals-list">
        {patientMedicationsLoading ? (
          Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="list-item sk">
              <Skeleton
                width={150}
                height={50}
                animation="wave"
                sx={{ bgcolor: darkMode ? "grey.800" : "" }}
              />
              <Skeleton
                width={200}
                height={30}
                animation="wave"
                sx={{ bgcolor: darkMode ? "grey.800" : "" }}
              />
            </div>
          ))
        ) : Array.isArray(patientMedications) ? (
          patientMedications?.map((medications, index) => (
            <div className="pc-leftpanel-list-item" key={index}>
              <div className="d-flex">
                <div className="first">
                  <div className="icon-box">
                    <LuPill color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
                  </div>

                  <div className="vital-details">
                    <p>{medications?.itemName}</p>
                    <p>{medications?.dose}</p>
                    <p>
                      {medications?.quantity
                        ? `Times: ${medications?.quantity}`
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="type">
                  <p
                    style={{
                      backgroundColor:
                        medications?.therapyLevel === 1
                          ? "#dcfce7"
                          : medications?.therapyLevel === 2
                          ? "#fee2e2"
                          : medications?.therapyLevel === 3
                          ? "#ffedd5"
                          : "",
                      color:
                        medications?.therapyLevel === 1
                          ? "#829079"
                          : medications?.therapyLevel === 2
                          ? "#b91c1c"
                          : medications?.therapyLevel === 3
                          ? "#c2410c"
                          : "",
                    }}
                  >
                    {medications?.therapyLevel === 1
                      ? "Chronic"
                      : medications?.therapyLevel === 2
                      ? "Acute"
                      : medications?.therapyLevel === 3
                      ? "Maintanence"
                      : medications?.therapyLevel === 4
                      ? "As needed"
                      : ""}
                  </p>
                </div>
              </div>
              <div className="a-actions">
                <MdOutlineEdit
                  color="grey"
                  size={20}
                  className="icons-pointer pc-action-icons"
                  onClick={() => handleEditClick(medications)}
                />
                <FaRegTrashAlt
                  color="red"
                  size={15}
                  className=" icons-pointer pc-action-icons"
                  onClick={() => handleDeleteClick(medications)}
                />
              </div>
            </div>
          ))
        ) : (
          <p>No medications found.</p>
        )}
      </div>
    </div>
  );
}
